<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-3">
        <input-select-search
          ref="anoLetivoId"
          :label="$t(`ACADEMICO.ANO_LETIVO`)"
          :options="opcoes.anosLetivos"
          v-model="filtro.anoLetivoId"
          @input="listarSegmentacoes"
          required
        />
      </div>
      <div class="col-12 col-md-3">
        <input-select-search
          ref="segmentacaoId"
          :label="$t(`ACADEMICO.SEGMENTACAO`)"
          :options="opcoes.segmentacoes"
          v-model="filtro.segmentacaoId"
          :isDisabled="!filtro.anoLetivoId"
          @input="listarCursos"
          required
        />
      </div>
      <div class="col-12 col-md-3">
        <input-select-search
          ref="cursoId"
          :label="$t(`ACADEMICO.CURSO`)"
          :options="opcoes.cursos"
          v-model="filtro.cursoId"
          :isDisabled="!filtro.segmentacaoId"
          @input="listarTurmas"
          required
        />
      </div>
      <div class="col-12 col-md-3">
        <input-select-search
          ref="turmaId"
          :label="$t(`ACADEMICO.TURMA`)"
          :options="opcoes.turmas"
          v-model="filtro.turmaId"
          :isDisabled="!filtro.cursoId"
          @input="listarDisciplinas"
          required
        />
      </div>
      <div class="col-12 col-md-3">
        <input-select-search
          ref="disciplinaId"
          :label="$t(`ACADEMICO.DISCIPLINA`)"
          :options="opcoes.disciplinas"
          v-model="filtro.disciplinaId"
          :isDisabled="!filtro.turmaId"
          required
        />
      </div>
      <div class="col-12 col-md-auto align-items-center">
        <b-button
          variant="primary"
          class="botao-acao-filtro w-100"
          @click="filtrar"
        >
          {{ $t('GERAL.FILTRAR') }}
        </b-button>
      </div>
      <div class="col-12 col-md-auto">
        <b-button
          variant="secondary"
          class="botao-acao-filtro mt-3 w-100"
          @click="limparFiltro"
        >
          {{ $t('GERAL.LIMPAR') }}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import CursoService from '@/common/services/academico/curso.service';
import TurmaService from '@/common/services/academico/turma.service';
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import DisciplinasService from '@/common/services/academico/disciplinas.service';

import { InputSelectSearch } from '@/components/inputs';

export default {
  components: {
    InputSelectSearch,
  },
  data() {
    return {
      filtro: {
        anoLetivoId: null,
        segmentacaoId: '',
        cursoId: '',
        turmaId: '',
        disciplinaId: '',
      },
      opcoes: {
        anosLetivos: [],
        cursos: [],
        segmentacoes: [],
        turmas: [],
        disciplinas: [],
      },
    };
  },
  mounted() {
    this.listarAnosLetivo();
    this.$emit('refs', this.$refs);
  },
  methods: {
    listarAnosLetivo() {
      this.filtro.segmentacaoId = null;
      this.filtro.cursoId = null;
      this.filtro.turmaId = null;
      this.filtro.disciplinaId = null;
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar(this.paginacao)
        .then(({ data }) => {
          data.forEach((element) => {
            element.text = element.ano;
            element.value = element.id;
          });
          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarSegmentacoes() {
      this.filtro.segmentacaoId = null;
      this.filtro.cursoId = null;
      this.filtro.turmaId = null;
      this.filtro.disciplinaId = null;
      this.opcoes.anosLetivos.forEach((element) => {
        if (element.id == this.filtro.anoLetivoId) {
          this.opcoes.segmentacoes = element.segmentacoes;
          console.log('this.opcoes.segmentacoes ', this.opcoes.segmentacoes)
          this.opcoes.segmentacoes.forEach((segmentacao) => {
            segmentacao.text = segmentacao.descricao;
            segmentacao.value = segmentacao.id;
          });
        }
      });
    },
    listarCursos() {
      this.filtro.cursoId = null;
      this.filtro.turmaId = null;
      this.filtro.disciplinaId = null;
      if (!this.filtro.anoLetivoId) return;
      this.$store.dispatch(START_LOADING);
      CursoService.obterPorAnoLetivo(this.filtro.anoLetivoId)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.cursos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarTurmas() {
      this.filtro.turmaId = null;
      this.filtro.disciplinaId = null;
      if (!this.filtro.cursoId || !this.filtro.anoLetivoId) return;
      this.$store.dispatch(START_LOADING);
      TurmaService.ObterPorCursoIdAnoLetivoId(
        this.filtro.cursoId,
        this.filtro.anoLetivoId
      )
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.turmas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarDisciplinas() {
      this.mostrarDisciplina = true;
      if (!this.filtro.turmaId) return;
      this.$store.dispatch(START_LOADING);
      DisciplinasService.buscarPorTurmaId(this.filtro.turmaId)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.disciplinas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES FILTRO:
    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },
    filtrar() {
      if (!this.validarFiltro()) return;
      const segmentacaoSelecionada = this.opcoes.segmentacoes.find(i => i.id == this.filtro.segmentacaoId)
      this.$emit('filtrar', {
        filtro: JSON.parse(JSON.stringify(this.filtro)),
        segmentacao: segmentacaoSelecionada
      });
    },
    limparFiltro() {
      this.filtro = {
        anoLetivoId: '',
        cursoId: '',
        segmentacaoId: '',
        turmaId: '',
        disciplinaId: ''
      };
      this.$emit('limparFiltro', { limpeza: true });
    },
  },
};
</script>
